import { render, staticRenderFns } from "./BaseOpportunityTag.vue?vue&type=template&id=2f67f136&scoped=true"
import script from "./BaseOpportunityTag.vue?vue&type=script&lang=js"
export * from "./BaseOpportunityTag.vue?vue&type=script&lang=js"
import style0 from "./BaseOpportunityTag.vue?vue&type=style&index=0&id=2f67f136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67f136",
  null
  
)

export default component.exports